module.exports = __webpack_public_path__ + "c95a91318bd3e368a2ed02531bd88eb7.svg";